module.exports = __webpack_public_path__ + "img/common-residential.5f24ad18.png";